<h1 mat-dialog-title>{{ 'UNSAVED_CHANGES.DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>{{ 'UNSAVED_CHANGES.DIALOG.CONTENT' | translate }}</div>
<div mat-dialog-actions>
  <ant-button color="primary" (click)="abort()" prefix="UNSAVED_CHANGES.DIALOG." actionName="ABORT"></ant-button>
  <ant-button color="warn" (click)="accept()" prefix="UNSAVED_CHANGES.DIALOG." actionName="ACCEPT"></ant-button>
</div>
